(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["index~popconfirm"],{

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var omit_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
/* harmony import */ var _tooltip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34);
/* harmony import */ var _tooltip_abstractTooltipProps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70);
/* harmony import */ var utils_vue_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var _utils_props_util__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);
/* harmony import */ var _utils_BaseMixin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4);
/* harmony import */ var _base_locale_provider_LocaleReceiver__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15);
/* harmony import */ var _base_locale_provider_default__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(43);
/* harmony import */ var base_config_provider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










var tooltipProps = Object(_tooltip_abstractTooltipProps__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"])();
var Popconfirm = {
  name: "MegPopconfirm",
  props: _objectSpread(_objectSpread({}, tooltipProps), {}, {
    prefixCls: utils_vue_types__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].string,
    // transitionName: PropTypes.string.def("zoom-big"),
    content: utils_vue_types__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].any,
    title: utils_vue_types__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].any,
    trigger: tooltipProps.trigger.def("click"),
    okType: utils_vue_types__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].string,
    disabled: utils_vue_types__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].bool.def(false),
    okText: utils_vue_types__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].any,
    cancelText: utils_vue_types__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].any,
    icon: utils_vue_types__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].any,
    okButtonProps: utils_vue_types__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].object,
    cancelButtonProps: utils_vue_types__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].object
  }),
  mixins: [_utils_BaseMixin__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"]],
  model: {
    prop: "visible",
    event: "visibleChange"
  },
  watch: {
    visible: function visible(val) {
      this.sVisible = val;
    }
  },
  inject: {
    configProvider: {
      default: function _default() {
        return base_config_provider__WEBPACK_IMPORTED_MODULE_8__["ConfigConsumerProps"];
      }
    }
  },
  data: function data() {
    var props = Object(_utils_props_util__WEBPACK_IMPORTED_MODULE_4__["getOptionProps"])(this);
    var state = {
      sVisible: false
    };

    if ("visible" in props) {
      state.sVisible = props.visible;
    }

    if ("defaultVisible" in props) {
      state.sVisible = props.defaultVisible;
    }

    return state;
  },
  methods: {
    onConfirm: function onConfirm(e) {
      this.setVisible(false, e);
      this.$emit("confirm", e);
    },
    onCancel: function onCancel(e) {
      this.setVisible(false, e);
      this.$emit("cancel", e);
    },
    onVisibleChange: function onVisibleChange(sVisible) {
      var disabled = this.$props.disabled;

      if (disabled) {
        return;
      }

      this.setVisible(sVisible);
    },
    setVisible: function setVisible(sVisible, e) {
      if (!Object(_utils_props_util__WEBPACK_IMPORTED_MODULE_4__["hasProp"])(this, "visible")) {
        this.setState({
          sVisible: sVisible
        });
      }

      this.$emit("visibleChange", sVisible, e);
    },
    getPopupDomNode: function getPopupDomNode() {
      return this.$refs.tooltip.getPopupDomNode();
    },
    renderOverlay: function renderOverlay(prefixCls, popconfirmLocale) {
      var h = this.$createElement;
      var _this$okType = this.okType,
          okType = _this$okType === void 0 ? "primary" : _this$okType,
          okButtonProps = this.okButtonProps,
          cancelButtonProps = this.cancelButtonProps;
      var icon = Object(_utils_props_util__WEBPACK_IMPORTED_MODULE_4__["getComponentFromProp"])(this, "icon") || h("meg-icon", {
        attrs: {
          name: "megui-fill-warn"
        }
      });
      var cancelBtnProps = Object(_utils_props_util__WEBPACK_IMPORTED_MODULE_4__["mergeProps"])({
        props: _objectSpread({
          size: "small"
        }, cancelButtonProps),
        on: {
          click: this.onCancel
        }
      });
      var okBtnProps = Object(_utils_props_util__WEBPACK_IMPORTED_MODULE_4__["mergeProps"])({
        props: _objectSpread({
          type: okType,
          size: "small"
        }, okButtonProps),
        on: {
          click: this.onConfirm
        }
      });
      return h("div", {
        "class": "".concat(prefixCls, "-inner-content")
      }, [h("div", {
        "class": "".concat(prefixCls, "-message")
      }, [icon, h("div", {
        "class": "".concat(prefixCls, "-message-title")
      }, [Object(_utils_props_util__WEBPACK_IMPORTED_MODULE_4__["getComponentFromProp"])(this, "title")])]), h("div", {
        "class": "".concat(prefixCls, "-buttons")
      }, [h("meg-button", cancelBtnProps, [Object(_utils_props_util__WEBPACK_IMPORTED_MODULE_4__["getComponentFromProp"])(this, "cancelText") || popconfirmLocale.cancelText]), h("meg-button", okBtnProps, [Object(_utils_props_util__WEBPACK_IMPORTED_MODULE_4__["getComponentFromProp"])(this, "okText") || popconfirmLocale.okText])])]);
    }
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var props = Object(_utils_props_util__WEBPACK_IMPORTED_MODULE_4__["getOptionProps"])(this);
    var customizePrefixCls = props.prefixCls;
    var getPrefixCls = this.configProvider.getPrefixCls;
    var prefixCls = getPrefixCls("popover", customizePrefixCls);
    var otherProps = Object(omit_js__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])(props, ["title", "content", "cancelText", "okText"]);
    var tooltipProps = {
      props: _objectSpread(_objectSpread({}, otherProps), {}, {
        prefixCls: prefixCls,
        visible: this.sVisible
      }),
      ref: "tooltip",
      on: {
        visibleChange: this.onVisibleChange
      }
    };
    var overlay = h(_base_locale_provider_LocaleReceiver__WEBPACK_IMPORTED_MODULE_6__[/* default */ "a"], {
      attrs: {
        componentName: "Popconfirm",
        defaultLocale: _base_locale_provider_default__WEBPACK_IMPORTED_MODULE_7__[/* default */ "a"].Popconfirm
      },
      scopedSlots: {
        default: function _default(popconfirmLocale) {
          return _this.renderOverlay(prefixCls, popconfirmLocale);
        }
      }
    });
    return h(_tooltip__WEBPACK_IMPORTED_MODULE_1__["default"], tooltipProps, [h("template", {
      slot: "title"
    }, [overlay]), this.$slots.default]);
  }
};

Popconfirm.install = function (Vue) {
  Vue.component(Popconfirm.name, Popconfirm);
};

/* harmony default export */ __webpack_exports__["default"] = (Popconfirm);

/***/ })

}]);